import { ClinicInsightDashboardType, userType } from "../../DTO";
import { Api } from "../api";
import { convertClinicInsights } from "./shared";

export const FetchClinicInsights = (user: userType) => {
    return new Promise<{ insights: ClinicInsightDashboardType }>(
        (resolve, reject) => {
            const api = new Api({
                method: "get",
                path: "clinic/patients/insights",
                header: {
                    Authorization: `Bearer ${user.access_token}`,
                },
            });

            return api
                .call()
                .then((data: any) => {
                    resolve({
                        insights: convertClinicInsights(data?.data ?? data),
                    });
                })
                .catch((err: any) => reject(err));
        },
    );
};
